const authManager = {
  setAccessToken: (useAccessToken) => {
    try {
      localStorage.setItem("useAccessToken", useAccessToken);
    } catch (error) {
      console.error("Error setting access token:", error);
    }
  },

  getAccessToken: () => {
    if (typeof window === "undefined") return null;
    return localStorage.getItem("useAccessToken");
  },

  deleteAccessToken: () => {
    if (typeof window !== "undefined") {
      localStorage.removeItem("useAccessToken");
    }
  },

  hasAccessToken: () => {
    if (typeof window === "undefined") return false;
    return !!localStorage.getItem("useAccessToken");
  },

  setRole: (role) => {
    try {
      localStorage.setItem("role", role);
    } catch (error) {
      console.error("Error setting access token:", error);
    }
  },

  getRole: () => {
    if (typeof window === "undefined") return null;
    return localStorage.getItem("role");
  },

  deleteRole: () => {
    if (typeof window !== "undefined") {
      localStorage.removeItem("role");
    }
  },
  setUserProfile: (data) => {
    try {
      localStorage.setItem("user", JSON.stringify(data));
    } catch (error) {
      console.error("Error setting user profile:", error);
    }
  },

  getUserProfile: () => {
    if (typeof window === "undefined") return null;

    const user = localStorage.getItem("user");

    if (!user) return null;

    try {
      return JSON.parse(user);
    } catch (e) {
      console.error("Invalid JSON in localStorage for key 'user':", user);
      return null;
    }
  },

  deleteUserProfile: () => {
    if (typeof window !== "undefined") {
      localStorage.removeItem("user");
    }
  },
};

export default authManager;
